import makeStyles from '@mui/styles/makeStyles';

export const styleComponentItem = makeStyles(() => ({
  itemIcon: {
    marginTop: 7,
  },
  itemIconHeader: {
    marginBottom: "20px !important",
  },
}));

const styles = makeStyles(() => ({
  infoComponent: {
    display: "flex",
    padding: "1rem 24px",
  },
  title: {
    fontFamily: "Manrope",
    fontSize: "10px",
    fontWeight: 700,
    lineHeight: "14px",
    color: "#9CA6AF",
  },
  info: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "16px",
  },
  colorNotGoing: {
    color: "#F97066",
  },
  colorQuantity: {
    color: "#465869",
  },
  colorIcon: {
    color: "#308CDB",
  },
  infoComponentItem: {
    width: "145px",
    marginRight: "72px",
  },
  infoComponentItemHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    marginBottom: "12px",
    "& svg": {
      fontSize: "30px",
    },
    "& p": {
      fontWeight: "bold",
    },
  },
  infoComponentItemList: {
    listStyle: "none",
    "& li": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& span:nth-child(2)": {
        fontWeight: "bold",
      },
    },
  },
}));

export default styles;
